import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminProductionProcesses } from '@/api/(admin)/production-processes';
import type { AdminProductionProcess } from '@/api/(admin)/production-processes/types';
import { buildProductionProcessesQs } from '../-utils/listParams';

/** Prefix for every cache entry, so one invalidation clears list + details. */
export const productionProcessesQueryKey = [
  'admin',
  'production-processes',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function productionProcessesQueryOptions() {
  return queryOptions({
    queryKey: [...productionProcessesQueryKey, 'list'] as const,
    queryFn: () => fetchAdminProductionProcesses(buildProductionProcessesQs()),
  });
}

export function useProductionProcesses() {
  const query = useQuery(productionProcessesQueryOptions());
  const rows: AdminProductionProcess[] = query.data?.data ?? [];
  return { ...query, rows };
}
